(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const announcementSlides = document.querySelectorAll('[data-announcement-popup-trigger]');

    announcementSlides.forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        // Prevent default link behavior if there's a link
        const link = slide.querySelector('.announcement-bar__link');
        if (link) {
          e.preventDefault();
        }

        // Open newsletter popup if the function is available
        if (typeof window.openNewsletterPopup === 'function') {
          window.openNewsletterPopup();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
